export default __webpack_public_path__ + "static/media/robot.455402be.svg";